import { NavLink, useNavigate } from "react-router-dom";
import logo from "../assets/logo.png";
import { authService } from "../services/auth";

export default function Header({ keycloak }) {
  const navigate = useNavigate();
  const isAuthenticated = authService.isAuthenticated() || (keycloak && keycloak.authenticated);

  const handleWhatsApp = () => {
    const phoneNumber = "5511918783914"; // Número do WhatsApp do setor de vendas
    const message = encodeURIComponent("Olá! Gostaria de falar com o setor de vendas sobre o Sistema Único - Imobiliárias.");
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, "_blank");
  };

  return (
    <header className="nav-bar">
      <div className="brand">
        <img
          src={logo}
          alt="Sistema Único - Imobiliárias"
          className="brand-logo"
        />
      </div>
      <nav className="nav-links">
        <NavLink to="/" end>🏠 Início</NavLink>
        <NavLink to="/listings">🔍 Anúncios</NavLink>
        <button
          type="button"
          onClick={handleWhatsApp}
          style={{ 
            padding: "0.625rem 1.125rem",
            borderRadius: "var(--radius-md)",
            background: "#25D366",
            border: "none",
            color: "#ffffff",
            fontSize: "0.9rem",
            fontWeight: 500,
            cursor: "pointer",
            transition: "var(--transition)",
            display: "flex",
            alignItems: "center",
            gap: "0.375rem",
            fontFamily: "inherit"
          }}
          onMouseEnter={(e) => {
            e.target.style.background = "#20BA5A";
            e.target.style.transform = "translateY(-1px)";
          }}
          onMouseLeave={(e) => {
            e.target.style.background = "#25D366";
            e.target.style.transform = "translateY(0)";
          }}
        >
          💬 Falar com Vendas
        </button>
        {isAuthenticated && (
          <>
            <NavLink to="/portfolio">📋 Portfólio</NavLink>
            <NavLink to="/contracts">📄 Contratos</NavLink>
            <NavLink to="/landlords">👤 Locadores</NavLink>
            <NavLink to="/tenants">🏠 Locatários</NavLink>
            <NavLink to="/bills">💳 Contas a Pagar</NavLink>
            <NavLink to="/condominiums">🏢 Condomínios</NavLink>
            <NavLink to="/shares">📊 Cotas</NavLink>
            <button
              className="btn-secondary"
              type="button"
              onClick={() => {
                authService.logout();
                if (keycloak && keycloak.authenticated) {
                  keycloak.logout({ redirectUri: window.location.origin + "/" });
                }
              }}
              style={{ 
                background: "rgba(255, 255, 255, 0.2)",
                border: "1px solid rgba(255, 255, 255, 0.3)",
                color: "#ffffff"
              }}
            >
              Sair
            </button>
          </>
        )}
        {!isAuthenticated && (
          <>
            <button
              type="button"
              onClick={() => navigate("/register")}
              style={{ 
                padding: "0.625rem 1.125rem",
                borderRadius: "var(--radius-md)",
                background: "rgba(255, 255, 255, 0.2)",
                border: "1px solid rgba(255, 255, 255, 0.3)",
                color: "#ffffff",
                fontSize: "0.9rem",
                fontWeight: 500,
                cursor: "pointer",
                transition: "var(--transition)",
                display: "flex",
                alignItems: "center",
                fontFamily: "inherit"
              }}
              onMouseEnter={(e) => {
                e.target.style.background = "rgba(255, 255, 255, 0.25)";
                e.target.style.transform = "translateY(-1px)";
              }}
              onMouseLeave={(e) => {
                e.target.style.background = "rgba(255, 255, 255, 0.2)";
                e.target.style.transform = "translateY(0)";
              }}
            >
              Cadastre-se
            </button>
            <button
              type="button"
              onClick={() => navigate("/login")}
              style={{ 
                padding: "0.625rem 1.125rem",
                borderRadius: "var(--radius-md)",
                background: "rgba(255, 255, 255, 0.2)",
                border: "1px solid rgba(255, 255, 255, 0.3)",
                color: "#ffffff",
                fontSize: "0.9rem",
                fontWeight: 500,
                cursor: "pointer",
                transition: "var(--transition)",
                display: "flex",
                alignItems: "center",
                fontFamily: "inherit"
              }}
              onMouseEnter={(e) => {
                e.target.style.background = "rgba(255, 255, 255, 0.25)";
                e.target.style.transform = "translateY(-1px)";
              }}
              onMouseLeave={(e) => {
                e.target.style.background = "rgba(255, 255, 255, 0.2)";
                e.target.style.transform = "translateY(0)";
              }}
            >
              Entrar
            </button>
          </>
        )}
      </nav>
    </header>
  );
}
